import * as React from 'react';
import TerrificBridge from 'react-terrific-bridge';

import Icon from 'components/atoms/Icon';
import Image from 'components/atoms/Image';
import { ImageProps } from 'components/atoms/Image';
import Knob from 'components/atoms/Knob';
import OverlayTemplate from 'components/molecules/Overlay/Template';
import { createRef } from 'react';

export type LightboxPinterestProps = {
	page: string;
	media: string;
	description: string;
};

export type LightboxProps = {
	image: ImageProps;
	pinterest?: LightboxPinterestProps | void;
};

export default class Lightbox extends React.Component<LightboxProps> {
	private componentRef: React.RefObject<HTMLDivElement>;

	constructor(props: LightboxProps) {
		super(props);
		this.componentRef = createRef();
	}

	public componentDidMount(): void {
		TerrificBridge.registerComponent(this.componentRef.current);
	}

	public componentWillUnmount(): void {
		TerrificBridge.unregisterComponent(this.componentRef.current);
	}

	public pinterestUrl(data: LightboxPinterestProps): string {
		const baseUrlPinterest = 'https://pinterest.com/pin/create/button/&amp;';

		return [
			baseUrlPinterest,
			`url=${data.page}&amp;`,
			`media=${data.media}&amp`,
			`description=${data.description}`,
		].join('');
	}

	public render() {
		const { image, pinterest }: LightboxProps = this.props;

		return (
			<div className="m-lightbox" data-t-name="Lightbox" ref={this.componentRef}>
				<OverlayTemplate closable closeButton animation="zoom" contentStyle="full" />
				<div className="m-lightbox__trigger">
					<Knob modifier="filled" size="s" icon="plus" />
				</div>
				<div className="lity-hide">
					<div className="m-lightbox__image js-m-lightbox__content">
						<Image srcset={image.srcset} title={image.title} alt={image.alt} />
						{/* eslint-disable */}
						{pinterest && (
							<a className="m-lightbox__pinterest" href={this.pinterestUrl(pinterest)} target="_blank">
								<span className="m-lightbox__icon">
									<Icon iconName="pinterest" />
								</span>
							</a>
						)}
						{/* eslint-enable */}
					</div>
				</div>
			</div>
		);
	}
}
